<template>
  <div class="p-4">
    <img
      class="ml-auto mr-auto w-72"
      src="@/assets/nucleus-logo-1.svg"
      alt="Nucleus Logo SVG"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  //   props: {
  //     heading: String,
  //   },
})
export default class Logo extends Vue {}
</script>
